import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import useQueries from '../../../../database/useQueries';
import useQueryGraves from '../../../../database/filters/queriesGrave';
import { DataContext, TemplateContext } from '../../pagesMains/GravesManagers/Graves';
import ColumnOrderingGrid from '../../../template/table';
import { mapFieldValues, onClickRow } from '../../plagins/utility';
import { format } from 'date-fns';
import { GlobalContext } from '../../../../App';
import { createFetchDataServer, createFetchDataServerWithCallback, fetchDataFromServerFullWithCallback, getTableData } from '../../../../database/fetchData';

const TabContentColumnsHistory = ({ grave }) => {
  // קבלת ערכים מהסטור
  const optionsFields = useSelector((state) => state.dataOptionsFieldsHe.data);
  const columns = useSelector((state) => state.columnsTablePurchases.data);
  const { searchText } = useContext(TemplateContext);
  const { token } = useContext(GlobalContext);

  const context = useContext(DataContext);
  const fetchDataServer = createFetchDataServer(context);
  // const fetchDataServerWithCallback = createFetchDataServerWithCallback(context);

  // טעינת היוזים לפונקציות עזר
  const { getSummaryByAreaGrave } = useQueryGraves();
  const { getEntityByAttr } = useQueries();

  // ערכי הראוטר
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true); // מצב טעינה

  const mappedData = mapFieldValues(context?.contextPurchasesOld, optionsFields)
    .filter((item) => item?.graveId === grave?.unicId)
    .map((item) => {
      const client = getEntityByAttr(context?.contextCustomers, 'unicId', item?.clientId);
      const grave = getEntityByAttr(context?.contextGraves, 'unicId', item?.graveId);
      const areaGrave = getEntityByAttr(context?.contextAreaGraves, 'gravesList', grave?.areaGraveId);
      const line = getEntityByAttr(context?.contextRows, 'unicId', areaGrave?.lineId);
      const plot = getEntityByAttr(context?.contextPlots, 'unicId', areaGrave?.plotId);
      const block = getEntityByAttr(context?.contextBlocks, 'unicId', plot?.blockId);
      const cemetery = getEntityByAttr(context?.contextCemeteries, 'unicId', block?.cemeteryId);

      const clientId = `${client?.firstName} ${client?.lastName}`;
      const dateOpening = format(new Date(item?.dateOpening), 'dd/MM/yyyy');

      const graveId = grave?.graveNameHe;
      const areaGraveId = areaGrave?.areaGraveNameHe;
      const lineId = line?.lineNameHe;
      const plotId = plot?.plotNameHe;
      const blockId = block?.blockNameHe;
      const cemeteryId = cemetery?.cemeteryNameHe;

      return {
        ...item,
        graveId,
        areaGraveId,
        lineId,
        plotId,
        blockId,
        cemeteryId,
        clientId,
        dateOpening
      };
    });

  useEffect(() => {
    async function loadTableData() {
      const localTempData = await getTableData('myDatabase', 'myStore');
      if (localTempData) {
        const dataCemeteries = localTempData.find((item) => item.name === 'dataCemeteries');
        const dataBlocks = localTempData.find((item) => item.name === 'dataBlocks');
        const dataPlots = localTempData.find((item) => item.name === 'dataPlots');
        const dataRows = localTempData.find((item) => item.name === 'dataRows');
        const dataAreaGraves = localTempData.find((item) => item.name === 'dataAreaGraves');
        const dataGraves = localTempData.find((item) => item.name === 'dataGraves');
        const dataPurchasesOld = localTempData.find((item) => item.name === 'dataPurchasesOld');
        if (dataCemeteries && dataBlocks && dataPlots && dataRows && dataAreaGraves && dataGraves && dataPurchasesOld) {
          setLoading(false);
        }
      }
      else {
        const handlePartialUpdate = (tableName) => {
          console.log(`Partial update received for table: ${tableName}`);
          setLoading(false);
        };
        // fetchDataServerWithCallback(['purchasesOld'], token, handlePartialUpdate);
  
        fetchDataServer(['cemeteries', 'blocks', 'plots', 'rows', 'areaGraves', 'graves', 'customers', 'purchasesOld'], token);
      }
    }
    loadTableData();
  }, []);

  return (
    <>
      <ColumnOrderingGrid gridHeight={360} rows={mappedData} columns={columns.filter((prop) => prop.show)} searchText={searchText} onRowSelect={(row) => onClickRow(row, getSummaryByAreaGrave, navigate)} />
    </>
  );
};

export default TabContentColumnsHistory;
